import { Review } from "@/Reviews";
import TrustPilotReviewsZH from "./tp_reviews_zh.json";
import TrustPilotReviews from "./tp_reviews.json";
import ReviewsIOProductReviews from "./reviewsio_product_reviews.json";

export const TPReviews: Review = TrustPilotReviews;
export const TPReviewsZH: Review = TrustPilotReviewsZH;
export const RIOProductReviews: Record<string, Review> = ReviewsIOProductReviews;
